import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const isEmailUsed = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "admins/isEmailUsed",
  async (email: string, { extra: { sharedRepository } }) => {
    return sharedRepository!.isEmailUsed(email);
  },
);

export const resetIsEmailUsed = createAction("admins/resetIsEmailUsed");
